<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="wlsq-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="申请状态">
              <el-select v-model="searchForm.type" style="width: 120px" filterable clearable @keyup.enter.native="search">
                <el-option label="待发货" :value="1" />
                <el-option label="已完成" :value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="search()">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button type="primary" class="add-btn" icon="el-icon-plus" @click="editApply(null)">添加申领</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-table
              v-loading="loading"
              :data="tableData"
              stripe
              style="width: 100%"
            >
              <el-table-column
                label="申请单号"
                width="180"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.manum }}</span>
                </template>
              </el-table-column>
              <el-table-column
                property="brandname"
                label="品牌"
                show-overflow-tooltip
                align="center"
                width="90"
              >
              </el-table-column>
              <el-table-column
                label="部门"
                width="120"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.deptname }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="申请人"
                width="120"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.username }}
                </template>
              </el-table-column>
              <el-table-column
                label="申请时间"
                width="170"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.applytime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="备注"
                min-width="180"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.remark!==null&&scope.row.remark!==''&&scope.row.remark!==undefined">{{ scope.row.remark }}</span>
                  <span v-if="scope.row.remark===null||scope.row.remark===''||scope.row.remark===undefined">N/A</span>
                </template>
              </el-table-column>
              <el-table-column
                label="申请状态"
                width="120"
                fixed="right"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.mark===0" :disable-transitions="true" size="mini" type="danger">待结清</el-tag>
                  <el-tag v-if="scope.row.mark===2" :disable-transitions="true" size="mini">已完成</el-tag>
                  <el-tag v-if="scope.row.mark===1" :disable-transitions="true" size="mini" type="warning">待发货</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="成本/元"
                fixed="right"
                align="center"
                width="120"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span style="font-weight: 500;color:#409EFF;">{{ scope.row.addprice }}</span>
                </template>
              </el-table-column>
              <el-table-column
                width="240"
                fixed="right"
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-dropdown v-if="scope.row.mark!==2&&(scope.row.opertime===null||scope.row.opertime===''||scope.row.opertime===undefined)" size="mini" split-button icon="el-icon-edit" @click="editApply(scope.row)">
                    <i class="el-icon-edit"></i> 编辑
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item style="color:#F56C6C" @click.native="delApply(scope.row)"><i class="el-icon-delete"></i> 删除申请</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-button v-if="(scope.row.mark!==2&&scope.row.opertime!==null&&scope.row.opertime!==''&&scope.row.opertime!==undefined)||scope.row.mark===2" icon="el-icon-search" size="mini" @click="view(scope.row)">查看详情</el-button>
                  <el-button icon="el-icon-printer" style="margin-left: 0" size="mini" @click="print(scope.row.maid)">打印</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="editVisible"
      width="900px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editForm" :model="editForm" label-width="70px" size="small" :rules="editRules">
        <el-row>
          <el-col :span="18">
            <el-form-item label="部门" prop="deptid" style="width:100%">
              <el-cascader
                ref="deptSelect"
                v-model="editForm.deptid"
                style="width: 100%"
                :options="deptTree"
                placeholder="试试搜索吧"
                filterable
                clearable
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="品牌" prop="bid" style="width:100%">
              <el-select v-model="editForm.bid" placeholder="请选择" clearable @change="changeBrand">
                <el-option v-if="user.dGroupid===2" label="乔金斯" :value="1"></el-option>
                <el-option v-if="user.dGroupid===1" label="首造" :value="3"></el-option>
                <el-option v-if="user.dGroupid===35" label="帆向" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-table
          ref="multipleTable"
          :data="materialList"
          size="small"
          border
          tooltip-effect="dark"
          show-summary
          :summary-method="getSummaries"
          :header-cell-style="{background:'#F5F7FA'}"
          style="width: 100%;margin-bottom: 10px"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="index"
            align="center"
            width="45"
          >
          </el-table-column>
          <el-table-column
            property="brandName"
            label="品牌"
            show-overflow-tooltip
            align="center"
            width="90"
          >
          </el-table-column>
          <el-table-column
            property="material_name"
            align="center"
            label="物料名称"
            show-overflow-tooltip
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            prop="img"
            align="center"
            label="图片"
            width="100"
          >
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.img"
                style="width: 80px; height: 80px"
                :src="scope.row.img"
                fit="contain"
                :preview-src-list="[scope.row.img]"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column
            property="material_spce"
            label="规格"
            show-overflow-tooltip
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            align="center"
            property="unit"
            label="单位"
            width="80"
          >
          </el-table-column>
          <el-table-column
            property="cost"
            label="单价/元"
            show-overflow-tooltip
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            type="selection"
            align="center"
            width="50"
          >
          </el-table-column>
          <el-table-column
            label="数量"
            align="center"
            width="155"
          >
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.counts" :disabled="scope.row.ischeck===false" :min="0" :max="99999999999" size="mini" @change="countSum()"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            label="成本/元"
            align="center"
            width="90"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.counts>0&&scope.row.ischeck" style="font-weight: 500;color:#409EFF">{{ (scope.row.counts*scope.row.cost).toFixed(2) }}</span>
              <span v-if="scope.row.counts<=0||scope.row.ischeck!==true" style="font-weight: 500;color:#909399">0</span>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item label="增加备注" prop="remark">
          <el-input v-model="editForm.remark" type="textarea" maxlength="300" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEdit('editForm')">立即提交</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="物料申领单详情"
      :visible.sync="viewVisible"
      width="800px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="viewForm" v-loading="viewLoading" :model="viewForm" label-width="80px" size="small">
        <div>
          <span style="color:#99a9bf;">申请单号：</span>
          <span>{{ viewForm.manum }}</span>
          <span style="color:#99a9bf;margin-left:30px">申请部门：</span>
          <span>{{ viewForm.deptname }}</span>
          <span style="color:#99a9bf;margin-left:30px">总价：</span>
          <span style="font-weight: 500;color:#409EFF">{{ viewForm.addprice }}</span>
        </div>
        <div style="margin:10px 0">
          <span style="color:#99a9bf;">增加备注：</span>
          <span v-if="viewForm.remark!==null&&viewForm.remark!==''&&viewForm.remark!==undefined">{{ viewForm.remark }}</span>
          <span v-if="viewForm.remark===null||viewForm.remark===''||viewForm.remark===undefined">N/A</span>
        </div>
        <el-table
          ref="multipleTable"
          :data="ViewMaterialList"
          size="small"
          border
          row-key="material_id"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          tooltip-effect="dark"
          :header-cell-style="{background:'#F5F7FA'}"
          style="width: 100%;margin-bottom: 10px"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="50"
          >
          </el-table-column>
          <el-table-column
            property="material_name"
            align="left"
            label="物料名称"
            show-overflow-tooltip
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            prop="img"
            align="center"
            label="图片"
            width="100"
          >
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.img"
                style="width: 80px; height: 80px"
                :src="scope.row.img"
                fit="contain"
                :preview-src-list="[scope.row.img]"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column
            property="brandName"
            label="品牌"
            show-overflow-tooltip
            align="center"
            width="90"
          >
          </el-table-column>
          <el-table-column
            property="material_spce"
            label="规格"
            show-overflow-tooltip
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            align="center"
            property="unit"
            label="单位"
            width="80"
          >
          </el-table-column>
          <el-table-column
            property="cost"
            label="单价/元"
            show-overflow-tooltip
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            label="成本/元"
            align="center"
            width="90"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.counts>0&&scope.row.ischeck" style="font-weight: 500;color:#409EFF">{{ (scope.row.counts*scope.row.cost).toFixed(2) }}</span>
              <span v-if="scope.row.counts<=0||scope.row.ischeck!==true" style="font-weight: 500;color:#909399">0</span>
            </template>
          </el-table-column>
          <el-table-column
            label="数量"
            align="center"
            width="90"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.counts }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <span style="color:#99a9bf;">处理人：</span>
          <span>{{ viewForm.opername }}</span>
          <span style="color:#99a9bf;margin-left:30px">处理时间：</span>
          <span>{{ viewForm.opertime }}</span>
        </div>
        <div style="margin:10px 0">
          <el-image
            v-for="iurl in imgSrcList"
            style="width: 60px; height: 60px;margin-right: 10px;"
            :src="iurl"
            :preview-src-list="imgSrcList"
          >
          </el-image>
        </div>
      </el-form>
    </el-dialog>
  </div>

</template>

<script>
import { getUser } from '@/utils/auth'
import {
  addOrEditMaterialClaim,
  getDeptTree,
  getMaterialClaimList,
  selectMaterialsList,
  selectMaterialsClaim,
  deleteMaterialClaim, printMaterialsClaim
} from '@/api/work'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'Wlsl',
  data() {
    return {
      fullscreenLoading: false,
      loading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      deptTree: [],
      searchForm: {
        search: '',
        type: null
      },
      editTitle: '',
      editVisible: false,
      editloading: false,
      editForm: {
        deptid: null,
        bid: 1,
        maid: 0,
        sumCost: 0,
        remark: ''
      },
      materialListAll: [],
      materialList: [],
      multipleSelection: [],
      editRules: {
        deptid: [{ required: true, message: '请选择部门', trigger: 'change' }],
        bid: [{ required: true, message: '请选择品牌', trigger: 'change' }]
      },
      viewVisible: false,
      viewLoading: false,
      ViewMaterialList: [],
      imgSrcList: [],
      viewForm: {
        maid: '',
        manum: '',
        deptname: '',
        addprice: 0,
        remark: '',
        username: '',
        opertime: '',
        opername: ''
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
    this.selectDeptTree()
  },
  methods: {
    changeBrand(bid) {
      if (bid !== null && bid !== undefined && bid !== '') {
        const _materialList = []
        for (const m of this.materialListAll) {
          if (bid === 1) {
            if (m.bid === 1 || m.bid === 2) {
              _materialList.push(m)
            }
          } else {
            if (m.bid === 3) {
              _materialList.push(m)
            }
          }
        }
        this.materialList = _materialList
      } else {
        this.materialList = this.materialListAll
      }
      this.multipleSelection = []
    },
    search() {
      this.currentPage = 1
      this.getData()
    },
    print(id) {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        this.fullscreenLoading = true
        printMaterialsClaim({ maid: id }).then(response => {
          LODOP.PRINT_INIT('物料申领单打印')
          LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')
          LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
          LODOP.ADD_PRINT_TABLE(30, '11mm', '100%', '100%', response.data)
          LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
          LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
          LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
          LODOP.NewPageA()
          LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
          LODOP.PREVIEW()
          this.fullscreenLoading = false
        }).catch(() => {
          this.fullscreenLoading = false
        })
      }
    },
    subEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            let details = ''
            for (const m of this.materialList) {
              if (m.ischeck && m.counts > 0) {
                details += m.material_id + ':' + m.counts + ','
              }
            }
            if (details.length <= 0) {
              this.$message.error('至少勾选一个物料并且数量不为0')
              return false
            }
            details = '{' + details.substring(0, details.length - 1) + '}'
            this.editloading = true
            const data = {
              userid: this.user.dUserid,
              deptid: this.editForm.deptid.toString().slice(-3),
              maid: this.editForm.maid,
              bid: this.editForm.bid,
              remark: this.editForm.remark,
              materialStr: details,
              price: this.editForm.sumCost
            }
            addOrEditMaterialClaim(data).then(response => {
              this.editloading = false
              this.editVisible = false
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          }
        }
      })
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 8) {
          sums[index] = '合计费用成本'
          return
        }
        if (index === 9) {
          this.countSum()
          sums[index] = this.editForm.sumCost
          return
        }
      })
      return sums
    },
    countSum() {
      var sum = 0
      for (var ma of this.materialList) {
        if (ma.ischeck) {
          sum += ma.counts * ma.cost
        }
      }
      this.editForm.sumCost = sum.toFixed(2)
    },
    getData() {
      this.loading = true
      const data = {
        status: this.searchForm.type,
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid
      }
      getMaterialClaimList(data).then(response => {
        this.total = response.total
        this.tableData = response.data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    selectDeptTree() {
      const data = {
        dGroupid: this.user.dGroupid
      }
      getDeptTree(data).then(response => {
        this.deptTree = response.data
      })
    },
    editApply(row) {
      this.editVisible = true
      if (row === null) {
        this.editTitle = '添加物料申领'
        this.editForm.deptid = null
        this.editForm.bid = null
        this.editForm.maid = 0
        this.editForm.sumCost = 0
        this.editForm.remark = ''
        selectMaterialsList().then(response => {
          this.materialListAll = response.data
          if (this.user.dGroupid === 1) {
            this.editForm.bid = 3
            this.changeBrand(3)
          } else {
            this.changeBrand(1)
          }
        })
      } else {
        this.editTitle = '编辑物料申领'
        selectMaterialsClaim({ maid: row.maid }).then(response => {
          this.editForm.deptid = 'dept@' + response.data.materialsClaim.deptid
          this.editForm.maid = response.data.materialsClaim.maid
          this.editForm.sumCost = response.data.materialsClaim.addprice
          this.editForm.remark = response.data.materialsClaim.remark
          this.materialListAll = response.data.materialsListVos
          const _this = this
          const old = []
          for (var i = 0; i < _this.materialListAll.length; i++) {
            if (_this.materialListAll[i].ischeck) {
              old.push(i)
            }
          }
          this.editForm.bid = row.bid
          this.changeBrand(row.bid)
          setTimeout(function() {
            for (const i of old) {
              _this.$refs.multipleTable.toggleRowSelection(_this.materialListAll[i])
            }
          }, 100)
        })
      }
    },
    delApply(row) {
      this.$confirm('删除此物料申请, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true
        deleteMaterialClaim({ maid: row.maid }).then(response => {
          this.fullscreenLoading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getData()
        }).catch(() => {
          this.fullscreenLoading = false
        })
      }).catch(() => {})
    },
    view(row) {
      this.imgSrcList = []
      this.ViewMaterialList = []
      this.viewForm.maid = row.maid
      this.viewForm.manum = row.manum
      this.viewForm.deptname = row.deptname
      this.viewForm.addprice = row.addprice
      this.viewForm.remark = row.remark
      this.viewForm.username = row.username
      this.viewForm.opertime = row.opertime
      this.viewForm.opername = row.opername
      this.viewLoading = true
      selectMaterialsClaim({ maid: row.maid }).then(response => {
        const imgs = []
        for (const c of response.data.materialsClaim.imgList) {
          imgs.push(c.imgUrl)
        }
        this.imgSrcList = imgs
        const ViewMaterialList = []
        for (const ma of response.data.materialsListVos) {
          if (ma.ischeck) {
            ViewMaterialList.push(ma)
          }
        }
        this.viewVisible = true
        this.ViewMaterialList = ViewMaterialList
        this.viewLoading = false
      }).catch(() => {
        this.viewLoading = false
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      for (const m of this.materialList) {
        m.ischeck = false
        for (const c of this.multipleSelection) {
          if (m.material_id === c.material_id) {
            m.ischeck = true
            if (this.editForm.isnewbus === 1 && m.is_standard === 1) {
              if (m.counts === 0) {
                m.counts = m.standard
              }
            }
            break
          }
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    }
  }
}
</script>

<style scoped>

</style>
